import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { volumeIcon } from '../../components/icons';
import ReactIcon from '../Icons';
import {
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_AUDIO,
  MEDIA_TYPE_VIDEO,
} from '../../constants';

const zoomIcon = ReactIcon({ type: 'zoom_in' });

export default function QuestionMedia({
  type,
  source,
  thumbnail,
  mediaQuestionRefId,
  disableControl,
  refId,
}) {
  const videoObjectForStore = {
    refId,
    questionRefIds: [mediaQuestionRefId],
    secondsSeen: [],
    seen: false,
  };

  const videoAlreadyExistsIndex = (
    Pollfish.store.questionVideos || []
  ).findIndex((video) => video.refId === refId);

  if (type === MEDIA_TYPE_IMAGE) {
    return (
      <div id="questionImage" className="q-w-media">
        <img src={thumbnail} className="q-w-media__img" alt="" />
        <button
          type="button"
          className="q-w-media__zoom js-zoom-image"
          data-img-src={source}
          aria-label="Zoom image"
        >
          {zoomIcon}
        </button>
      </div>
    );
  }

  if (type === MEDIA_TYPE_VIDEO || type === MEDIA_TYPE_AUDIO) {
    if (isEmpty(Pollfish.store.questionVideos)) {
      Pollfish.store.questionVideos = [videoObjectForStore];
    } else if (videoAlreadyExistsIndex > -1) {
      Pollfish.store.questionVideos[
        videoAlreadyExistsIndex
      ].questionRefIds.push(mediaQuestionRefId);
    } else {
      Pollfish.store.questionVideos.push(videoObjectForStore);
    }
    const controlsList =
      type === MEDIA_TYPE_AUDIO ? 'nodownload nofullscreen' : 'nodownload';
    return (
      <div
        id={`questionVideo-${refId}`}
        className={`q-w-media ${disableControl ? 'disabled-controls' : ''}`}
      >
        <div className="embed-responsive embed-responsive-16by9">
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            id={`video-${refId}`}
            data-video-ref-id={refId}
            data-question-ref-id={mediaQuestionRefId}
            preload="auto"
            poster={thumbnail}
            webkit-playsinline
            playsinline
            controlsList={controlsList}
          >
            <source src={source} type="video/mp4" />
            Your device does not support HTML5 video.
          </video>
          <svg
            onClick={() => {
              Pollfish.ui.handleVideo(refId, disableControl);
            }}
            className="video-overlay-play-button"
            viewBox="0 0 200 200"
            alt="Play video"
          >
            <circle
              cx="100"
              cy="100"
              r="90"
              fill="none"
              strokeWidth="15"
              stroke="#fff"
            ></circle>
            <polygon points="70, 55 70, 145 145, 100" fill="#fff"></polygon>
          </svg>
          {disableControl && (
            <div
              className="custom-video-controls"
              id={`questionVideo-${refId}-controls`}
            >
              <div className="progress">
                <progress
                  className="video-progress-bar"
                  value="0"
                  min="0"
                  max="100"
                >
                  0% played
                </progress>
              </div>
              <span
                id={`volume-button-${refId}`}
                className="volume-button"
                data-video-ref-id={refId}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: volumeIcon }}
              />
              <input
                type="range"
                id={`volume-bar-${refId}`}
                title="volume"
                min="0"
                max="1"
                step="0.1"
                value="1"
                onChange={() => {
                  Pollfish.ui.changeVideoVolume(refId);
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  return null;
}

QuestionMedia.propTypes = {
  type: PropTypes.string,
  source: PropTypes.string,
  thumbnail: PropTypes.string,
  mediaQuestionRefId: PropTypes.string,
  refId: PropTypes.string,
  disableControl: PropTypes.bool,
};
